// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Percent20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Percent20Circle: FC<Percent20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M9.208 9.208A.964.964 0 0 1 8.5 9.5a.964.964 0 0 1-.708-.292A.964.964 0 0 1 7.5 8.5c0-.278.097-.514.292-.708A.964.964 0 0 1 8.5 7.5c.278 0 .514.097.708.292.195.194.292.43.292.708a.964.964 0 0 1-.292.708ZM16.208 16.208a.964.964 0 0 1-.708.292.964.964 0 0 1-.708-.292.964.964 0 0 1-.292-.708c0-.278.097-.514.292-.708a.964.964 0 0 1 .708-.292c.278 0 .514.097.708.292.195.194.292.43.292.708a.964.964 0 0 1-.292.708Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM6.73 10.267A2.4 2.4 0 0 0 8.495 11a2.42 2.42 0 0 0 1.77-.73A2.399 2.399 0 0 0 11 8.505a2.42 2.42 0 0 0-.73-1.77A2.399 2.399 0 0 0 8.505 6a2.42 2.42 0 0 0-1.77.73A2.399 2.399 0 0 0 6 8.495c0 .691.243 1.282.73 1.77Zm7 7a2.4 2.4 0 0 0 1.766.733 2.42 2.42 0 0 0 1.77-.73A2.4 2.4 0 0 0 18 15.505a2.42 2.42 0 0 0-.73-1.77A2.4 2.4 0 0 0 15.505 13a2.42 2.42 0 0 0-1.77.73A2.4 2.4 0 0 0 13 15.495c0 .691.243 1.282.73 1.77ZM6 16.937 7.063 18 18 7.062 16.937 6 6 16.938Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Percent20Circle;
